import React, {Component} from 'react'
import {Spinner} from '@blueprintjs/core'

class Loading extends Component {
    render() {
        return (
            <div style ={{ textAlign: "center", position: "absolute", top: "25%", left: "50%"}}>
            <Spinner />
            </div>
        )
    }
}

export default Loading


// WEBPACK FOOTER //
// ./src/components/Loading.jsx